module.exports = __webpack_public_path__ + "img/profit_b.a5fcf5c8.svg";